module.exports = __webpack_public_path__ + "img/mano.06d49db3.svg";